import React, {FC} from "react";
import {UserActor} from "interfaces";
import {AppNames} from "enums";

export const ModerationUserActors: FC<{ users: UserActor[] }> = ({users}) => {
    return <>{users.map((u, i) =>
        <div key={u.key + i}>
            <a href={`profile/${u.key}`} target="_blank"
               rel="noreferrer">{u.name ?? u.key} ({u.appId ? `${AppNames[u.appId]}, ` : ''}{u.status})</a>
        </div>)}
    </>
}